// A recording card's 16:9 frame (decision 47, as Adam changed it on 12 Oct; product/recordingThumbs.js
// has the rules): Adam's own thumbnail filling it, or, where the recording has none, or its link won't
// load after signing once more, the grey date panel with the day it was recorded, in the product's own
// look (product.css: .rthumb and --pp-panel). It's free/Thumbnail.jsx's frame, so it behaves exactly as
// a webinar's: empty while its link is being signed, decorative (the card's words say what it is), and
// spans all the way down, since some cards are links. A search hit of Property Cashflow For Life's
// (card.module) keeps the course's own dark green module panel instead of the date, as its cards do
// (products/ondemand/parts.jsx Thumb; Adam, 12 Oct): its module's side of the pentagon, dimmed while the
// recording isn't open to them. The module's label is left off at the hit's 80px, where the hit's own
// words beside it name the module.
//
//   const thumbs = useRecordingThumbs(cards)   1 hook per page, signing every card's thumbnail at once
//   <RecordingThumb card={card.thumb} thumbs={thumbs} className="..." />
import { useThumbnails } from '../free/thumbnails.js'
import { ThumbnailFrame } from '../free/Thumbnail.jsx'
import { ModuleMark } from '../products/ondemand/Pentagon.jsx'
import { itemsOf, thumbForHit } from './recordingThumbs.js'

// The page's signed links for its cards' thumbnails (cards: cardThumb answers, nulls left out)
export function useRecordingThumbs(cards) {
  return useThumbnails(itemsOf(cards), 'recordings')
}

// The date as the panel draws it: the day of the week, the date and the month
export function PanelDate({ block }) {
  if (!block) return null
  return (
    <span className="rthumb-date">
      <span className="rthumb-edge">{block.dow}</span>
      <span className="rthumb-day">{block.day}</span>
      <span className="rthumb-edge">{block.mon}</span>
    </span>
  )
}

export function RecordingThumb({ card, thumbs, className = '' }) {
  if (!card) return null
  const item = card.item
  const frame = item ? thumbs.frame(item) : { url: null, pending: false }
  const module = card.module || null
  const look = module ? ` rthumb--module${module.open ? '' : ' rthumb--off'}` : ''
  return (
    <ThumbnailFrame thumb={frame} className={`rthumb${look}${className ? ` ${className}` : ''}`}
      onError={item ? e => thumbs.failed(item, e.currentTarget.src) : undefined}
      onLoad={item ? e => thumbs.loaded(item, e.currentTarget.src) : undefined}>
      {module
        ? (module.pentagon !== false && <span className="od-thumb-mark"><ModuleMark index={module.index} state="todo" size={null} dark /></span>)
        : <PanelDate block={card.block} />}
    </ThumbnailFrame>
  )
}

// The header search's hits with their recording's frame (decision 47, 12 Oct): [{ hit, card }], card
// null for a hit that isn't a recording of a product with a thumbnail, so it looks as before; the
// shown hits' thumbnails signed together. productId: only that product's recordings (a product's own
// header, so the looks never mix), none of any other's signed or drawn.
export function useHitThumbs(hits, index, { productId = null } = {}) {
  const rows = (hits || []).map(hit => {
    const card = thumbForHit(hit, index)
    return { hit, card: card && (!productId || card.productId === productId) ? card : null }
  })
  const thumbs = useRecordingThumbs(rows.map(r => r.card))
  return { rows, thumbs }
}
